export const splitArray = <T extends Record<string, any>>(
  array: Array<T>,
  filterFunction: (data: T) => boolean,
): { filteredData: Array<T>; remainData: Array<T> } => {
  return array.reduce(
    (acc: { filteredData: Array<T>; remainData: Array<T> }, el) => {
      const conditionMet = filterFunction(el);

      if (conditionMet) {
        acc.filteredData.push(el);
      } else {
        acc.remainData.push(el);
      }
      return acc;
    },
    { filteredData: [], remainData: [] },
  );
};
